/*
 *
 * DrawersPanel actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { LevelSelection } from 'containers/DrawersPanel/types';
import { Color } from 'lib/modelBuilder/entities/Color';

export const displayDrawersPanelAction = (value: boolean) =>
  action(ActionTypes.DISPLAY_DRAWERS_PANEL, { value });

export const selectionDrawersAction = (values: LevelSelection) =>
  action(ActionTypes.SELECTION_DRAWERS, { values });

export const updateDrawersAction = (color: Color, preview = false) =>
  action(ActionTypes.UPDATE_DRAWERS, { color, preview });
